import getRouterView from '@/router/helpers';

export default {
    path: '/rra',
    meta: {
        requiresAuth: true,
        title: 'Search',
        documentTitle: 'RRAs',
    },
    component: getRouterView(),
    children: [
        {
            path: '',
            name: 'RRASearch',
            meta: {
                title: 'Search',
                documentTitle: 'RRAs',
            },
            component: () => import( /* webpackChunkName: "RRASearch" */ '@/views/RRA/Search' ),
        },
        {
            path: 'autogen',
            name: 'RRAAutogen',
            meta: {
                title: 'AutoGen',
                documentTitle: 'RRA AutoGen',
            },
            component: () => import( /* webpackChunkName: "RRAAutoGen" */ '@/views/RRA/AutoGen' ),
        },
        {
            path: 'create',
            name: 'RRACreate',
            meta: {
                title: 'Create',
                documentTitle: 'Create RRA',
            },
            component: () => import( /* webpackChunkName: "RRACreateEdit" */ '@/views/RRA/Create' ),
        },
        {
            path: ':id',
            component: getRouterView(),
            meta: {
                title: 'Detail',
                documentTitle: 'RRA Detail',
            },
            children: [
                {
                    path: '',
                    name: 'RRADetail',
                    meta: {
                        title: 'Detail',
                        documentTitle: 'RRA Detail',
                    },
                    component: () => import( /* webpackChunkName: "RRACreateEdit" */ '@/views/RRA/Detail' ),
                },
                {
                    path: ':ean/:condition?',
                    name: 'RRAEANDetail',
                    meta: {
                        title: 'EAN Detail',
                        documentTitle: 'RRA EAN Detail',
                    },
                    component: () => import( /* webpackChunkName: "RRAEANDetail" */ '@/views/RRA/EANDetail' ),
                },
            ],
        },
    ],
};
